module.exports = __webpack_public_path__ + "media/assets/images/flags/nl-806a965771ff980ba0ad7178d07e2bed.svg";